import type { TableView } from "./export.types";

/**
 * O separador é o ponto e vírgula porque o Excel em português abre o arquivo
 * com esse delimitador sem pedir conversão; o BOM garante os acentos.
 */
export const CSV_SEPARATOR = ";";

const CSV_LINE_BREAK = "\r\n";

const UTF8_BOM = String.fromCharCode(0xfeff);

function escapeCell(value: string): string {
  const text = value ?? "";

  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

function toLine(cells: string[]): string {
  return cells.map(escapeCell).join(CSV_SEPARATOR);
}

export function buildCsvContent({ columns, rows }: TableView): string {
  return [toLine(columns), ...rows.map(toLine)].join(CSV_LINE_BREAK) + CSV_LINE_BREAK;
}

export function buildCsvFile(view: TableView): Uint8Array {
  return new TextEncoder().encode(`${UTF8_BOM}${buildCsvContent(view)}`);
}
